<form [formGroup]="form" class="flex flex-col">
    <section aria-labelledby="regulatory-status">
        <h3 class="application-section-header">Regulatory Status</h3>
        <hr class="mb-4" />
        <app-application-form-field fieldNumber="41" class="w-full">
            <div class="flex flex-col">
                <p class="!ml-2 !mb-0">
                    This filing is for authorization to provide or use the
                    following type(s) of radio service offering (choose all that
                    apply).<span class="text-error-700">*</span>
                </p>
                <div class="flex flex-wrap">
                    @for (
                        radioServiceOfferingCheckbox of radioServiceOfferingCheckboxes;
                        track radioServiceOfferingCheckbox.name
                    ) {
                        <mat-checkbox
                            color="primary"
                            [formControlName]="
                                radioServiceOfferingCheckbox.name
                            "
                            class="mr-4"
                            [ngClass]="{
                                'error-border':
                                    checkIfRadioServiceOfferingTouched() &&
                                    form.hasError(
                                        validationErrorKeys.atLeastOneRadioServiceOfferingRequired
                                    ),
                            }"
                        >
                            {{ radioServiceOfferingCheckbox.label }}
                        </mat-checkbox>
                    }
                </div>
            </div>
        </app-application-form-field>
    </section>

    <section aria-labelledby="type-of-radio-service">
        <h3 class="application-section-header">Type of Radio Service</h3>
        <hr class="mb-4" />
        <div class="flex flex-wrap w-full">
            <app-application-form-field fieldNumber="42" class="w-full">
                <div class="flex flex-col">
                    <p class="!ml-2 !mb-0">
                        This filing is for authorization to provide the
                        following type(s) of radio service (choose all that
                        apply).<span class="text-error-700">*</span>
                    </p>
                    <div class="flex flex-wrap">
                        @for (
                            radioServiceTypeCheckbox of radioServiceTypeCheckboxes;
                            track radioServiceTypeCheckbox.name
                        ) {
                            <mat-checkbox
                                color="primary"
                                [formControlName]="
                                    radioServiceTypeCheckbox.name
                                "
                                class="mr-4"
                                [ngClass]="{
                                    'error-border':
                                        checkIfRadioServiceTypeTouched() &&
                                        form.hasError(
                                            validationErrorKeys.atLeastOneRadioServiceTypeRequired
                                        ),
                                }"
                            >
                                {{ radioServiceTypeCheckbox.label }}
                            </mat-checkbox>
                        }
                    </div>
                </div>
            </app-application-form-field>

            <app-application-form-field
                fieldNumber="43"
                class="w-full xl:w-6/12"
                [tooltipMessage]="messages.isProvidingInterconnectedService"
                [showTooltipIcon]="true"
                [ellipsisLength]="45"
            >
                <mat-form-field appearance="outline" class="w-full">
                    <mat-label
                        >Applicant to Provide Interconnected Service?</mat-label
                    >
                    <mat-select
                        formControlName="isProvidingInterconnectedService"
                    >
                        @for (
                            yesNoOption of yesNoOptions;
                            track yesNoOption.value
                        ) {
                            <mat-option [value]="yesNoOption.value">{{
                                yesNoOption.label
                            }}</mat-option>
                        }
                    </mat-select>
                </mat-form-field>
            </app-application-form-field>
        </div>
    </section>

    <section aria-labelledby="alien-ownsership-questions">
        <h3 class="application-section-header">
            Alien Ownership Questions (If any answer is 'Y', provide an
            attachment explaining the circumstances)
        </h3>
        <hr class="mb-4" />
        <div class="flex flex-col w-full">
            <div class="w-full grid grid-cols-12">
                <app-application-form-field
                    fieldNumber="44"
                    class="w-full xl:col-span-6"
                    [ngClass]="
                        form.controls.isForeignGovernment.value
                            ? 'col-span-9'
                            : 'col-span-12'
                    "
                    [tooltipMessage]="messages.isForeignGovernment"
                    [showTooltipIcon]="true"
                    [ellipsisLength]="59"
                >
                    <mat-form-field appearance="outline" class="w-full">
                        <mat-label
                            >Is Applicant a Foreign Government (or
                            Representative)?</mat-label
                        >
                        <mat-select formControlName="isForeignGovernment">
                            @for (
                                yesNoOption of yesNoOptions;
                                track yesNoOption.value
                            ) {
                                <mat-option [value]="yesNoOption.value">{{
                                    yesNoOption.label
                                }}</mat-option>
                            }
                        </mat-select>
                    </mat-form-field>
                </app-application-form-field>
                @if (form.controls.isForeignGovernment.value) {
                    <div class="flex ml-5 col-span-3 2xl:col-span-2">
                        <app-attachment-required-button class="w-full" />
                    </div>
                }
            </div>

            <div class="w-full grid grid-cols-12">
                <app-application-form-field
                    fieldNumber="45"
                    class="w-full xl:col-span-6"
                    [ngClass]="
                        form.controls.isAlien.value
                            ? 'col-span-9'
                            : 'col-span-12'
                    "
                    [tooltipMessage]="messages.isAlien"
                    [showTooltipIcon]="true"
                    [ellipsisLength]="60"
                >
                    <mat-form-field appearance="outline" class="w-full">
                        <mat-label
                            >Is Applicant an Alien (or
                            Representative)?</mat-label
                        >
                        <mat-select formControlName="isAlien">
                            @for (
                                yesNoOption of yesNoOptions;
                                track yesNoOption.value
                            ) {
                                <mat-option [value]="yesNoOption.value">{{
                                    yesNoOption.label
                                }}</mat-option>
                            }
                        </mat-select>
                    </mat-form-field>
                </app-application-form-field>
                @if (form.controls.isAlien.value) {
                    <div class="flex ml-5 col-span-3 2xl:col-span-2">
                        <app-attachment-required-button class="w-full" />
                    </div>
                }
            </div>

            <div class="w-full grid grid-cols-12">
                <app-application-form-field
                    fieldNumber="46"
                    class="w-full xl:col-span-6"
                    [ngClass]="
                        form.controls.isAlienCorporation.value
                            ? 'col-span-9'
                            : 'col-span-12'
                    "
                    [tooltipMessage]="messages.isAlienCorporation"
                    [showTooltipIcon]="true"
                    [ellipsisLength]="55"
                >
                    <mat-form-field appearance="outline" class="w-full">
                        <mat-label
                            >Is Applicant a Corporation Under a
                            Foreign...</mat-label
                        >
                        <mat-select formControlName="isAlienCorporation">
                            @for (
                                yesNoOption of yesNoOptions;
                                track yesNoOption.value
                            ) {
                                <mat-option [value]="yesNoOption.value">{{
                                    yesNoOption.label
                                }}</mat-option>
                            }
                        </mat-select>
                    </mat-form-field>
                </app-application-form-field>
                @if (form.controls.isAlienCorporation.value) {
                    <div class="flex ml-5 col-span-3 2xl:col-span-2">
                        <app-attachment-required-button class="w-full" />
                    </div>
                }
            </div>

            <div class="w-full grid grid-cols-12">
                <app-application-form-field
                    fieldNumber="47"
                    class="w-full xl:col-span-6"
                    [ngClass]="
                        form.controls.isAlienOfficer.value
                            ? 'col-span-9'
                            : 'col-span-12'
                    "
                    [tooltipMessage]="messages.isAlienOfficer"
                    [showTooltipIcon]="true"
                    [ellipsisLength]="59"
                >
                    <mat-form-field appearance="outline" class="w-full">
                        <mat-label
                            >Is Applicant a Corporation Which One
                            Fifth...</mat-label
                        >
                        <mat-select formControlName="isAlienOfficer">
                            @for (
                                yesNoOption of yesNoOptions;
                                track yesNoOption.value
                            ) {
                                <mat-option [value]="yesNoOption.value">{{
                                    yesNoOption.label
                                }}</mat-option>
                            }
                        </mat-select>
                    </mat-form-field>
                </app-application-form-field>
                @if (form.controls.isAlienOfficer.value) {
                    <div class="flex ml-5 col-span-3 2xl:col-span-2">
                        <app-attachment-required-button class="w-full" />
                    </div>
                }
            </div>

            <div class="w-full grid grid-cols-12">
                <app-application-form-field
                    fieldNumber="48a"
                    class="w-full xl:col-span-6"
                    [ngClass]="
                        form.controls.isAlienControl.value
                            ? 'col-span-9'
                            : 'col-span-12'
                    "
                    [tooltipMessage]="messages.isAlienControl"
                    [showTooltipIcon]="true"
                    [ellipsisLength]="63"
                >
                    <mat-form-field appearance="outline" class="w-full">
                        <mat-label
                            >Is Applicant Directly or Indirectly
                            Controlled...</mat-label
                        >
                        <mat-select formControlName="isAlienControl">
                            @for (
                                yesNoOption of yesNoOptions;
                                track yesNoOption.value
                            ) {
                                <mat-option [value]="yesNoOption.value">{{
                                    yesNoOption.label
                                }}</mat-option>
                            }
                        </mat-select>
                    </mat-form-field>
                </app-application-form-field>
                @if (form.controls.isAlienControl.value) {
                    <div class="flex ml-5 col-span-3 2xl:col-span-2">
                        <app-attachment-required-button class="w-full" />
                    </div>
                }
            </div>

            <div class="flex flex-row space-x-5">
                <app-application-form-field fieldNumber="48b" class="">
                    <span
                        >If the answer to 47 or 48a is 'Y' select one of the
                        choices below.</span
                    >
                </app-application-form-field>
                @if (form.controls.alienRuling.value) {
                    <app-attachment-required-button class="w-60" />
                }
            </div>
            <div class="flex flex-col w-full px-12">
                @for (
                    alienRulingOption of alienRulingOptions;
                    track alienRulingOption.value
                ) {
                    <app-expandable-radio-button
                        class="mb-3"
                        [model]="alienRulingOption"
                        [isInvalid]="isAlienRulingInvalid()"
                        [isDisabled]="form.controls.alienRuling.disabled"
                        formControlName="alienRuling"
                    ></app-expandable-radio-button>
                }
            </div>
        </div>
    </section>

    <section aria-labelledby="basic-qualification-questions" class="mb-2">
        <h3 class="application-section-header">
            Basic Qualification Questions
        </h3>
        <hr class="mb-4" />
        <div class="flex flex-col w-full">
            <div class="w-full grid grid-cols-12">
                <app-application-form-field
                    fieldNumber="49"
                    class="w-full xl:col-span-6"
                    [ngClass]="
                        form.controls.isRevoked.value
                            ? 'col-span-9'
                            : 'col-span-12'
                    "
                    [tooltipMessage]="messages.isRevoked"
                    [showTooltipIcon]="true"
                    [ellipsisLength]="58"
                >
                    <mat-form-field appearance="outline" class="w-full">
                        <mat-label
                            >Applicant or Any Party Had Any FCC
                            Authorization/Application Revoked or
                            Denied?</mat-label
                        >
                        <mat-select formControlName="isRevoked">
                            @for (
                                yesNoOption of yesNoOptions;
                                track yesNoOption.value
                            ) {
                                <mat-option [value]="yesNoOption.value">{{
                                    yesNoOption.label
                                }}</mat-option>
                            }
                        </mat-select>
                    </mat-form-field>
                </app-application-form-field>
                @if (form.controls.isRevoked.value) {
                    <div class="flex ml-5 col-span-3 2xl:col-span-2">
                        <app-attachment-required-button class="w-full" />
                    </div>
                }
            </div>

            <div class="w-full grid grid-cols-12">
                <app-application-form-field
                    fieldNumber="50"
                    class="w-full xl:col-span-6"
                    [ngClass]="
                        form.controls.isConvictedFelon.value
                            ? 'col-span-9'
                            : 'col-span-12'
                    "
                    [tooltipMessage]="messages.isConvictedFelon"
                    [showTooltipIcon]="true"
                    [ellipsisLength]="58"
                >
                    <mat-form-field appearance="outline" class="w-full">
                        <mat-label
                            >Applicant or Any Party Convicted of
                            Felony?</mat-label
                        >
                        <mat-select formControlName="isConvictedFelon">
                            @for (
                                yesNoOption of yesNoOptions;
                                track yesNoOption.value
                            ) {
                                <mat-option [value]="yesNoOption.value">{{
                                    yesNoOption.label
                                }}</mat-option>
                            }
                        </mat-select>
                    </mat-form-field>
                </app-application-form-field>
                @if (form.controls.isConvictedFelon.value) {
                    <div class="flex ml-5 col-span-3 2xl:col-span-2">
                        <app-attachment-required-button class="w-full" />
                    </div>
                }
            </div>

            <div class="w-full grid grid-cols-12">
                <app-application-form-field
                    fieldNumber="51"
                    class="w-full xl:col-span-6"
                    [ngClass]="
                        form.controls.isCourtAdjudicated.value
                            ? 'col-span-9'
                            : 'col-span-12'
                    "
                    [tooltipMessage]="messages.isCourtAdjudicated"
                    [showTooltipIcon]="true"
                    [ellipsisLength]="57"
                >
                    <mat-form-field appearance="outline" class="w-full">
                        <mat-label
                            >Has Any Court Adjudged the Applicant or Any
                            Party?</mat-label
                        >
                        <mat-select formControlName="isCourtAdjudicated">
                            @for (
                                yesNoOption of yesNoOptions;
                                track yesNoOption.value
                            ) {
                                <mat-option [value]="yesNoOption.value">{{
                                    yesNoOption.label
                                }}</mat-option>
                            }
                        </mat-select>
                    </mat-form-field>
                </app-application-form-field>
                @if (form.controls.isCourtAdjudicated.value) {
                    <div class="flex ml-5 col-span-3 2xl:col-span-2">
                        <app-attachment-required-button class="w-full" />
                    </div>
                }
            </div>

            <div class="flex items-center">
                <img
                    src="assets/svg/info-icon-circle-blue.svg"
                    class="mr-2"
                    alt="info icon"
                />
                <span
                    >If any of the above are answered “Yes” attach an exhibit
                    explaining the circumstances</span
                >
            </div>
        </div>
    </section>

    <mat-accordion class="mb-5">
        <mat-expansion-panel>
            <mat-expansion-panel-header>
                <mat-panel-title
                    class="!text-tertiary-900 font-normal text-lg py-2"
                    >Items 52-56 – Not Applicable for Private
                    Wireless</mat-panel-title
                >
            </mat-expansion-panel-header>

            <section
                aria-labelledby="aeronautical-advisory-station-certification"
            >
                <h3 class="section-header">
                    Aeronautical Advisory Station (Unicom) Certification
                </h3>
                <hr class="mb-4" />
                <div class="flex flex-col w-full">
                    <app-application-form-field
                        fieldNumber="52"
                        class="w-full xl:w-6/12"
                        [tooltipMessage]="messages.isAeronautical"
                        [showTooltipIcon]="true"
                        [ellipsisLength]="57"
                    >
                        <mat-form-field appearance="outline" class="w-full">
                            <mat-label
                                >Station on Property of Served
                                Airport?</mat-label
                            >
                            <mat-select [disabled]="true"></mat-select>
                        </mat-form-field>
                    </app-application-form-field>
                </div>
            </section>

            <section
                aria-labelledby="broadband-radio-service-and-educational-broadband"
            >
                <h3 class="section-header">
                    Broadband Radio Service and Educational Broadband Service
                    Cable Cross-Ownership
                </h3>
                <hr class="mb-4" />
                <div class="flex flex-col w-full">
                    <app-application-form-field
                        fieldNumber="53a"
                        class="w-full xl:w-6/12"
                        [tooltipMessage]="messages.isMultichannel"
                        [showTooltipIcon]="true"
                        [ellipsisLength]="61"
                    >
                        <mat-form-field appearance="outline" class="w-full">
                            <mat-label
                                >Provide Multichannel Video Programming
                                Service?</mat-label
                            >
                            <mat-select [disabled]="true"></mat-select>
                        </mat-form-field>
                    </app-application-form-field>

                    <app-application-form-field
                        fieldNumber="53b"
                        class="w-full xl:w-6/12"
                        [tooltipMessage]="messages.isCableTv"
                        [showTooltipIcon]="true"
                        [ellipsisLength]="56"
                    >
                        <mat-form-field appearance="outline" class="w-full">
                            <mat-label
                                >Operate, Control, or Have Interest in Cable
                                Television?</mat-label
                            >
                            <mat-select [disabled]="true"></mat-select>
                        </mat-form-field>
                    </app-application-form-field>
                </div>
            </section>

            <section
                aria-labelledby="broadband-radio-service-and-educational-broadband-part-27"
            >
                <h3 class="section-header">
                    Broadband Radio Service and Educational Broadband Service
                    (Part 27)
                </h3>
                <hr class="mb-4" />
                <div class="flex flex-col w-full">
                    <app-application-form-field
                        fieldNumber="54"
                        class="w-full xl:w-6/12"
                        [tooltipMessage]="messages.isCompliantSection271203"
                        [showTooltipIcon]="true"
                        [ellipsisLength]="61"
                    >
                        <mat-form-field appearance="outline" class="w-full">
                            <mat-label
                                >Compliance With Section 27.1203?</mat-label
                            >
                            <mat-select [disabled]="true"></mat-select>
                        </mat-form-field>
                    </app-application-form-field>

                    <app-application-form-field
                        fieldNumber="55"
                        class="w-full xl:w-6/12"
                        [tooltipMessage]="messages.isCompliantSection27Others"
                        [showTooltipIcon]="true"
                        [ellipsisLength]="56"
                    >
                        <mat-form-field appearance="outline" class="w-full">
                            <mat-label
                                >Compliance With Sections 27.50, 27.55, &
                                27.1221?</mat-label
                            >
                            <mat-select [disabled]="true"></mat-select>
                        </mat-form-field>
                    </app-application-form-field>
                </div>
            </section>

            <section aria-labelledby="applicants-participated-in-an-auction">
                <h3 class="section-header">
                    For Applicants Who Participated in an Auction
                </h3>
                <hr class="mb-4" />
                <div class="flex flex-col w-full">
                    <app-application-form-field
                        fieldNumber="56"
                        class="w-full xl:w-6/12"
                        [tooltipMessage]="messages.isRuralPartnership"
                        [showTooltipIcon]="true"
                        [ellipsisLength]="56"
                    >
                        <mat-form-field appearance="outline" class="w-full">
                            <mat-label
                                >A Qualifying Rural Partnership?</mat-label
                            >
                            <mat-select [disabled]="true"></mat-select>
                        </mat-form-field>
                    </app-application-form-field>
                </div>
            </section>
        </mat-expansion-panel>
    </mat-accordion>

    <section aria-labelledby="operation-performance-requirement-certification">
        <h3 class="section-header">
            For Renewal Applicants - Operation/Performance Requirement
            Certification
        </h3>
        <hr class="mb-4" />
        <div class="flex flex-col w-full">
            <app-application-form-field fieldNumber="57" class="w-full">
                <span>Select one of the license types below.</span>
            </app-application-form-field>
            <div class="flex flex-col w-full px-12">
                <app-expandable-radio-button
                    class="mb-3"
                    [model]="operationPerformanceCertificationOption"
                    [isDisabled]="!areRenewalCertificationsEnabled()"
                    [isInvalid]="
                        isOperationPerformanceCertificationChoiceInvalid()
                    "
                    formControlName="operationPerformanceCertificationChoice"
                >
                    <mat-form-field
                        appearance="outline"
                        class="w-full xl:w-6/12"
                    >
                        <mat-label>Select an Option</mat-label>
                        <mat-select
                            formControlName="operationPerformanceCertificationAnswer"
                        >
                            @for (
                                yesNoOption of yesNoOptions;
                                track yesNoOption.value
                            ) {
                                <mat-option [value]="yesNoOption.value">
                                    {{ yesNoOption.label }}
                                </mat-option>
                            }
                        </mat-select>
                    </mat-form-field>
                </app-expandable-radio-button>

                <mat-accordion class="mb-5">
                    <mat-expansion-panel>
                        <mat-expansion-panel-header>
                            <mat-panel-title
                                class="!text-tertiary-900 font-normal text-lg py-2"
                                >Not Applicable for Private
                                Wireless</mat-panel-title
                            >
                        </mat-expansion-panel-header>
                        <div class="flex flex-col space-y-3">
                            @for (
                                operationPerformanceOption of getFilteredOperationPerformanceOptions();
                                track operationPerformanceOption.value
                            ) {
                                <app-expandable-radio-button
                                    [model]="operationPerformanceOption"
                                    [isDisabled]="true"
                                    formControlName="operationPerformanceCertificationChoice"
                                >
                                </app-expandable-radio-button>
                            }
                        </div>
                    </mat-expansion-panel>
                </mat-accordion>
            </div>
        </div>
    </section>

    <section
        aria-labelledby="discontinuance-of-service-certification"
        class="mb-5"
    >
        <h3 class="section-header">Discontinuance of Service Certification</h3>
        <hr class="mb-4" />
        <div class="flex flex-col w-full">
            <app-application-form-field
                fieldNumber="58"
                class="w-full xl:w-6/12"
                [tooltipMessage]="messages.hasDiscontinuanceOfService"
                [showTooltipIcon]="true"
                [ellipsisLength]="52"
            >
                <mat-form-field appearance="outline" class="w-full">
                    <mat-label
                        >No Permanent Discontinuance of Service</mat-label
                    >
                    <mat-select formControlName="hasDiscontinuanceOfService">
                        @for (
                            yesNoOption of yesNoOptions;
                            track yesNoOption.value
                        ) {
                            <mat-option [value]="yesNoOption.value">{{
                                yesNoOption.label
                            }}</mat-option>
                        }
                    </mat-select>
                </mat-form-field>
            </app-application-form-field>

            <mat-expansion-panel
                class="!bg-primary-50"
                #panel="matExpansionPanel"
            >
                <mat-expansion-panel-header>
                    <mat-panel-description class="py-3">
                        <img
                            src="assets/svg/flat-info-icon.svg"
                            class="mr-5"
                            alt="question mark"
                        />
                        <span class="text-black font-normal"
                            >{{
                                panel.expanded
                                    ? messages.attachAnExhibit
                                    : (messages.attachAnExhibit | ellipsis: 513)
                            }}
                        </span>
                    </mat-panel-description>
                </mat-expansion-panel-header>
            </mat-expansion-panel>
        </div>
    </section>

    <section aria-labelledby="regulatory-compliance-certification">
        <h3 class="section-header">Regulatory Compliance Certification</h3>
        <hr class="mb-4" />
        <div class="flex flex-col w-full">
            <app-application-form-field
                fieldNumber="59"
                class="w-full xl:w-6/12"
                [tooltipMessage]="messages.hasRegulatoryCompliance"
                [showTooltipIcon]="true"
                [ellipsisLength]="63"
                ><mat-form-field appearance="outline" class="w-full">
                    <mat-label
                        >Applicant Complies with All Applicable FCC
                        Rules...</mat-label
                    >
                    <mat-select formControlName="hasRegulatoryCompliance">
                        @for (
                            yesNoOption of yesNoOptions;
                            track yesNoOption.value
                        ) {
                            <mat-option [value]="yesNoOption.value">{{
                                yesNoOption.label
                            }}</mat-option>
                        }
                    </mat-select>
                </mat-form-field></app-application-form-field
            >
            <div class="flex items-center mb-4">
                <img
                    src="assets/svg/info-icon-circle-blue.svg"
                    class="mr-2"
                    alt="information icon"
                />
                <span
                    >Note: If the response to item 59 is ‘N’, attach an exhibit
                    explaining the circumstances and demonstrating why
                    Applicant’s license should be renewed.</span
                >
            </div>
        </div>
    </section>
</form>
